import { connect } from 'react-redux';

import CustomerComponent from './customer.component';

function mapStateToProps({}: any): any {
	return {};
}

function mapDispatchToProps(): any {
	return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(CustomerComponent);



// WEBPACK FOOTER //
// ./src/components/customer/customer/customer.ts